"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "ModeratorTagsComponent", {
  enumerable: true,
  get: function get() {
    return _ModeratorTagsComponent.default;
  }
});
Object.defineProperty(exports, "ModeratorTagsContext", {
  enumerable: true,
  get: function get() {
    return _ModeratorTagsContext.ModeratorTagsContext;
  }
});
Object.defineProperty(exports, "ModeratorTagsProvider", {
  enumerable: true,
  get: function get() {
    return _ModeratorTagsContext.ModeratorTagsProvider;
  }
});
Object.defineProperty(exports, "withModeratorTagsContext", {
  enumerable: true,
  get: function get() {
    return _ModeratorTagsContext.withModeratorTagsContext;
  }
});

var _ModeratorTagsContext = require("./ModeratorTagsContext");

var _ModeratorTagsComponent = _interopRequireDefault(require("./ModeratorTagsComponent"));